<div
  class="menu-responsive onlyMobile"
  [ngClass]="{'opened': _opened}"
>
  <div
    class="menu-wrap"
    [ngClass]="{'opened': _opened}"
  >
    <div class="login-top__usuario item-mobile">
      <a
        [routerLink]="['/home/usuario']"
        (click)="onMenuToggled()"
        class="nav-link"
        href="#"
        title=""
      >
        <span class="icono-img">
          <img
            src="assets/images/icons/user.svg"
            class="login-icon"
          >
        </span>
      </a>
      <span class="login-top__usuario__text">
        <span class="sr-only">Usuario:</span>{{ UserName }}</span>
    </div>
    <div class="item-mobile">
      <div class="scy-select-contrato">
        <div class="input-select">
          <div class="select">
            <label
              for="slct"
              class="slct"
            >Seleccione su contrato</label>
            <select
              name="slct"
              (change)="ContratoSeleccionado($event)"
              class="slct"
              [(ngModel)]="positionselected"
              required
            >
              <option
                *ngFor="let contrato of contratos; let i = index"
                value={{i}}
              >{{!contrato.Ficticio ? contrato.Codigo + ' - ' + contrato.InmuebleBO.Direccion : 'Facturas Cliente'}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <nav aria-label="Menú Principal">
      <ul class="menu-list">
        <li>
          <a
            [routerLink]="['/home/home']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/factura-grafico.svg">
            </span>
            <span>Resumen</span>
          </a>
        </li>
        <li *ngIf="!esFicticio">
          <a
            [routerLink]="['/home/lecturacontador']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/speed.svg">
            </span>
            <span>Lectura de contador</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/home/consumofactura']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/chart.svg">
            </span>
            <span>Consumo y facturas</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/domiciliacionFactura']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/domiciliacion.svg">
            </span>
            <span>Domiciliación de factura</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/datoscorrespondencia']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/correspondencia.svg">
            </span>
            <span>Datos de correspondencia</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/simuladorConsumo']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/consumos.svg">
            </span>
            <span>Simulador de consumos</span>
          </a>
        </li>
        <li class="hidden">
          <a href="#">
            <span class="menu-img">
              <img src="assets/images/icons/login.svg">
            </span>
            <span>Login</span>
          </a>
        </li>
        <li
          *ngIf="!esPagadorOInactivo && !esFicticio"
          class="contacto"
        >
          <a
            [routerLink]="['/home/baja']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/laptop.svg">
            </span>
            <span>Baja</span>
          </a>
        </li>
        <li class="contacto">
          <a
            [routerLink]="['/home/contact']"
            (click)="onMenuToggled()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/contacto.svg">
            </span>
            <span>Contacto</span>
          </a>
        </li>
        <li class="item-mobile">
          <a
            (click)="logout()"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img
                src="assets/images/icons/salir.svg"
                class="login-icon"
              >
            </span>
            <span>Salir</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>
